module.exports = __webpack_public_path__ + "static/media/theme_scifi.43d01181.jpg";